/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Bold_Ox_HikeInputs */

const fr_kind_bold_ox_hike = /** @type {(inputs: Kind_Bold_Ox_HikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle catégorie - Admin`)
};

/**

* @param {Kind_Bold_Ox_HikeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const kind_bold_ox_hike = /** @type {((inputs?: Kind_Bold_Ox_HikeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Bold_Ox_HikeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_kind_bold_ox_hike(inputs)
});